import { withConcurrency } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { Cta } from '#/components/cta.tsx';
import { GoToTop } from '#/components/layout/goto-top.tsx';
import { GITHUB_LINK } from '#/components/layout/goto-top.utils.ts';
import { WorkBreadcrumb } from '#/components/works/work-breadcrumb.tsx';
import { WorkDetails } from '#/components/works/work-details.tsx';
import { WorkNav } from '#/components/works/work-nav.tsx';
import { seo, siteConfig } from '@/lib/config/site';

export const Route = createFileRoute('/_main/work/$slug')({
	component: WorkDetailPage,
	async loader({ context, params }) {
		const {
			results: [project],
		} = await withConcurrency([
			context.trpc.project.bySlug.ensureData({ slug: params.slug }),
			context.trpc.project.descriptionBySlug.ensureData({ slug: params.slug }),
			context.trpc.project.allSlugs.ensureData(),
		]);

		if (!project) throw notFound({ data: { message: m.work_not_found() } });
		return { project };
	},
	head({ loaderData, params }) {
		const project = loaderData?.project;
		const tags = seo({
			title: project?.title ?? params.slug,
			image: project?.url ?? siteConfig.ogImage,
			url: `${siteConfig.canonical}/work/${params.slug}`,
		});
		return { meta: tags.meta, links: tags.links };
	},
});

function WorkDetailPage() {
	return (
		<>
			<WorkBreadcrumb />
			<section className="container pt-16 pb-20 lg:py-20">
				<WorkDetails />
				<WorkNav className="py-10" />
			</section>
			<Hydrate when={idle()}>
				<Cta className="container" />
			</Hydrate>
			<GoToTop
				links={[
					{ href: '/works', icon: 'lucide:container', label: m.work_all() },
					GITHUB_LINK,
				]}
			/>
		</>
	);
}
